import { Tools } from "../system/Tools";
import { Game } from "./game";
import * as PIXI from 'pixi.js'



let loader: { key: string; data: any }[] = [];

try {
  const context = require.context('../assets/', true, /\.(mp3|png|jpe?g)$/);
  loader = Tools.massiveRequire(context);
} catch (error) {
  console.error("Error loading sprites:", error);
  // Optionally provide a default or fallback value
  loader = [];
  // console.log('LOADER', loader)
}

export const Config = {
  scenes: {
    Game
  },
  loader,
  graphStartPoint: {
    //starting point for 0(x,y) point of the graph
    startX: (App: PIXI.Application) => App.renderer.width * 8 / 100,//starting x point (small offset for labels) 
    startY: (App: PIXI.Application) => App.renderer.height - App.renderer.height * 7 / 100 //starting y point (small offset for labels)
  },
  axis: {
    maxXvalue: 8,  //max time value initially on xAxis
    maxYvalue: 1.8,  //max multiplier value initially on yAxis
    minYvalue: 1.2, //min multiplier value on yAxis

    xStartTime: 10000, //time after which xAxis labels move
    yStartTime: 11000, //time after which yAxis labels move

    xStep: 2, //step on xAxis
    yStep: 0.2, // step on yAxis

    xLabelOffset: 20, // between X Axis and its labels
    yLabelOffset: 0, // between Y Axis and its albels

    xlabelInterval: 1300, //interval of creating x labels 2000
    yLabelInterval: 250, // interval of creating y labels 1500


    xStepsNumber:10,
    yStepsNumber:5
  },
  curve: {
    curveDefaultColor: '#C4B406',
    curveGreenColor: '#408609',
    backgroundCurveStroke: 3, //3 default
    foregroundCurveStroke: 4.7,   // should be bigger than the background curve to prevent showing the edges 4.7 default
    curveOscillationSpeed: 0.3, // curve oscilation speed 0.3 as default
    oscillationAmount: 0.01 // curve oscilation percant 0.01 as default
  }

};


export type ConfigType = typeof Config
export type SceneType = keyof typeof Config.scenes